import { useEffect, useState } from 'react';
import { KeyRound, Loader2, X } from 'lucide-react';
import { updatePassword } from '../services/supabase';
import { toast } from './Toaster';

function PasswordResetDialog({ open, status = 'ready', onClose }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setPassword('');
    setConfirmPassword('');
    setError('');
  }, [open]);

  if (!open) return null;

  const submit = async (event) => {
    event.preventDefault();
    if (password.length < 8) {
      setError('Use at least 8 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await updatePassword(password);
      toast('Password updated successfully.', 'success');
      onClose();
    } catch (err) {
      setError(err?.message || 'The reset link is invalid or expired. Request a new link.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="settings-overlay" onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose();
    }}>
      <section className="password-reset-modal panel glow-card" role="dialog" aria-modal="true" aria-labelledby="password-reset-title">
        <button type="button" className="settings-close" onClick={onClose} aria-label="Close password reset"><X size={18} /></button>
        <span className="account-panel-icon" aria-hidden="true"><KeyRound size={22} /></span>
        <p className="eyebrow">Secure account</p>
        <h2 id="password-reset-title">
          {status === 'checking' ? 'Validating reset link' : status === 'invalid' ? 'Reset link unavailable' : 'Choose a new password'}
        </h2>
        {status === 'checking' ? (
          <div className="account-loading" role="status"><Loader2 size={20} className="spin-icon" /> Checking the secure reset link…</div>
        ) : status === 'invalid' ? (
          <div className="account-card-stack">
            <p className="account-error" role="alert">This password-reset link is invalid or expired. Request a new link using your registered email address.</p>
            <button type="button" className="primary-button" onClick={onClose}>Return to sign in</button>
          </div>
        ) : (
          <>
            <p>This password will be used for your AWN AdPulse email sign-in.</p>
            <form className="account-form" onSubmit={submit}>
              <label>
                New password
                <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="new-password" required />
              </label>
              <label>
                Confirm new password
                <input type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} autoComplete="new-password" required />
              </label>
              {error && <p className="account-error" role="alert">{error}</p>}
              <button type="submit" className="primary-button" disabled={busy}>
                {busy ? <Loader2 size={16} className="spin-icon" /> : <KeyRound size={16} />}
                {busy ? 'Updating…' : 'Update password'}
              </button>
            </form>
          </>
        )}
      </section>
    </div>
  );
}

export default PasswordResetDialog;
